// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
//import { Auth } from 'aws-amplify'


import { GetTeachersInput, GetSchoolsInput, GetClassroomsInput, GetStudentsInput, GetEPathsInput, GetUsersInput, GetUserInput,
        GetContentsInput, GetContentInput, GetAssessmentInput, GetAssessmentsInput, AssessmentData, GetAssessmentByIdInput, GetSchoolListInput } from 'API';
import type { Teacher, School, Classroom, Student, EPath, User, Content, Assessment,SchoolList  } from 'utils/types'
import { getStudents, getTeachers, getSchools, getClassrooms, getEPaths, getUsers, getUser, getContents, getSchoolList,
        getContent, getAssessment, getAssessments, getAssessmentById } from 'graphql/queries'

//const endpoint = 'https://zwdipxfacjbjtl476ukatveq3u.appsync-api.us-west-2.amazonaws.com/graphql' // query endpoint DEV
const endpoint = 'https://lhh6gczkrjesjcul4ekaiiw6ce.appsync-api.us-west-2.amazonaws.com/graphql' // Staging queryAPI


// const apikey = "da2-nt7c4yogszb2jouziudl2slbvy" // FIX THIS ! DEV
const apikey = 'da2-kqimotq2cfeh3ljmrb4l4uolau' // STAGING


console.log("API KEY", apikey)

const baseTeacherQuery = `query GET_TEACHERS($getTeachersInput: GetTeachersInput!) {
    getTeachers(getTeachersInput: $getTeachersInput) {
      data {
        PK
        SK
        id
        code
        firstName
        lastName
        email
        classes
        status
        school
        createdAt
        updatedAt
      }
      nextToken
    }
  }`


// Define our single API slice object
export const queryApi = createApi({
    // The cache reducer expects to be added at `state.api` (already default - this is optional)
    reducerPath: 'queryapi',
    // All of our requests will have URLs starting with '/fakeApi'
    baseQuery: fetchBaseQuery({        
        baseUrl: endpoint,
        prepareHeaders: (headers, query) => {
            // let res = await Auth.currentSession()
            // console.log(res)
            // let accessToken = res.getAccessToken()
            // if (accessToken) {
            //     let jwt = accessToken.getJwtToken()
            //     console.log(`Headers Jwt: ${jwt}`)
            //     headers.set('authorization', jwt)
            // } else {
                // if (!apikey)  { console.log("No API Key"); return undefined }
                headers.set('x-api-key',apikey)
            // }
            headers.set('content-type', 'application/json')
            console.log("Headers :",headers,apikey )
           return headers
        }
    }),
    tagTypes: ['TeacherQ', 'SchoolQ', 'ClassroomQ', 'StudentQ', 'EPathQ', 'UserQ', 'ContentQ', 'AssessmentQ', 'SchoolList'],
    // The "endpoints" represent operations and requests for this server
    endpoints: builder => ({
      // The `getPosts` endpoint is a "query" operation that returns data
        getTeachers: builder.query<
                [Teacher], {getTeachersInput: GetTeachersInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getTeachersInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getTeachers,
                    "variables": {getTeachersInput: getTeachersInput}
                },
             }),
             providesTags: ['TeacherQ'],
             transformResponse: (response: {data: {getTeachers: {data: [Teacher], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getTeachers.data as [Teacher]},
        }),
        getSchools: builder.query<
                [School], {getSchoolsInput: GetSchoolsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getSchoolsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getSchools,
                    "variables": {getSchoolsInput: getSchoolsInput}
                },
             }),
             providesTags: ['SchoolQ'],
             transformResponse: (response: {data: {getSchools: {data: [School], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getSchools.data as [School]},
        }),
        getSchoolList: builder.query<
                [SchoolList], {getSchoolListInput: GetSchoolListInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getSchoolListInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getSchoolList,
                    "variables": {getSchoolListInput: getSchoolListInput}
                },
             }),
             providesTags: ['SchoolList'],
             transformResponse: (response: {data: {getSchoolList: {data: [SchoolList], nextToken: string}}} ) => {
                console.log("SchoolList Response: ",response)
                return response.data.getSchoolList.data as [SchoolList]},
        }),
        getStudents: builder.query<
                [Student], {getStudentsInput: GetStudentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getStudentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getStudents,
                    "variables": {getStudentsInput: getStudentsInput}
                },
             }),
             providesTags: ['StudentQ'],
             transformResponse: (response: {data: {getStudents: {data: [Student], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getStudents.data as [Student]},
        }),
        getClassrooms: builder.query<
                [Classroom], {getClassroomsInput: GetClassroomsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getClassroomsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getClassrooms,
                    "variables": {getClassroomsInput: getClassroomsInput}
                },
             }),
             providesTags: ['ClassroomQ'],
             transformResponse: (response: {data: {getClassrooms: {data: [Classroom], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getClassrooms.data as [Classroom]},
        }),
        getPaths: builder.query<
                [EPath], {getEPathsInput: GetEPathsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getEPathsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getEPaths,
                    "variables": {getEPathsInput: getEPathsInput}
                },
             }),
             providesTags: ['EPathQ'],
             transformResponse: (response: {data: {getEPaths: {data: [EPath], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getEPaths.data as [EPath]},
        }),
        getContents: builder.query<
        [Content], {getContentsInput: GetContentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getContentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getContents,
                    "variables": {getContentsInput: getContentsInput}
                },
            }),
            providesTags: ['ContentQ'],
            transformResponse: (response: {data: {getContents: {data: [Content], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getContents.data as [Content]},
        }),
        getContent: builder.query<
        Content, {getContentInput: GetContentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getContentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getContent,
                    "variables": {getContentInput: getContentInput}
                },
            }),
            providesTags: ['ContentQ'],
            transformResponse: (response: {data: {getContent: {data: Content}}} ) => {
                console.log("Response: ",response)
                return response.data.getContent.data as Content},
        }),
        getUsers: builder.query<
                [User], {getUsersInput: GetUsersInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getUsersInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getUsers,
                    "variables": {getUsersInput: getUsersInput}
                },
             }),
             providesTags: ['UserQ'],
             transformResponse: (response: {data: {getUsers: {data: [User], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getUsers.data as [User]},
        }),
        getUser: builder.query<
                User, {getUserInput: GetUserInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getUserInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getUser,
                    "variables": {getUserInput: getUserInput}
                },
             }),
             providesTags: ['UserQ'],
             transformResponse: (response: {data: {getUser: {data: User}}} ) => {
                console.log("Get User Response: ",response, response.data.getUser.data)
                return response.data.getUser.data as User},
        }),
        getAssessment: builder.query<
                Assessment, {getAssessmentInput: GetAssessmentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getAssessmentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getAssessment,
                    "variables": {getAssessmentInput: getAssessmentInput}
                },
             }),
             providesTags: ['AssessmentQ'],
             transformResponse: (response: {data: {getAssessment: {data: Assessment}}} ) => {
                console.log("Response: ",response)
                return response.data.getAssessment.data as Assessment},
        }),
        getAssessmentById: builder.query<
                AssessmentData, {getAssessmentByIdInput: GetAssessmentByIdInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getAssessmentByIdInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getAssessmentById,
                    "variables": {getAssessmentByIdInput: getAssessmentByIdInput}
                },
            }),
            providesTags: ['AssessmentQ'],
            transformResponse: (response: {data: {getAssessmentById: {data: AssessmentData}}} ) => {
                console.log("Response: ",response)
                return response.data.getAssessmentById.data as AssessmentData},
        }),

        getAssessments: builder.query<
                [Assessment], {getAssessmentsInput: GetAssessmentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getAssessmentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getAssessments,
                    "variables": {getAssessmentsInput: getAssessmentsInput}
                },
             }),
             providesTags: ['AssessmentQ'],
             transformResponse: (response: {data: {getAssessments: {data: [Assessment], nextToken: string}}} ) => {
                console.log("GetAssessments Response: ",response)
                return response.data.getAssessments.data as [Assessment]},
        }),

 
    })
})
  
// Export the auto-generated hook for the  query endpoint
export const { 
  useGetTeachersQuery, 
  useGetSchoolsQuery,
  useGetStudentsQuery, 
  useGetClassroomsQuery,
  useGetPathsQuery,
  useGetUsersQuery,
  useGetUserQuery,
  useGetContentsQuery,
  useGetAssessmentQuery,
  useGetAssessmentsQuery,
  useGetAssessmentByIdQuery,
  useGetSchoolListQuery,
  } = queryApi

